import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { FormMetaModel, SmMetaInputModel, SmMetaFileModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";

export class StudentAssignmentDetailsMetaModel extends FormMetaModel {
    constructor() {
      super('', ROUTE_PATH.studentAssignment, ROUTE_PATH.assignment_details, 1);
    }
    override initProperties(): any {
      const formInfo = super.initProperties();
  
      const description = new SmMetaInputModel(
        'description',
        'description',
        'input',
        false,
        'col-6 col-md-6',
        1,
        1,
        'Description ',
        'text',
        '',
        true
      );
  
      const document_path = new SmMetaFileModel(
        'display_filename',
        'display_filename',
        'input',
        false,
        'col-6 col-md-6',
        1,
        1,
        '',
        'text',
        '',
        true
      );
      const student_feedback = new SmMetaTextAreaModel(
        'student_feedback',
        'student_feedback',
        'SimpleTextarea',
        false,
        'col-12 ',
        1,
        2,
        'Add Feedback',
        'textarea',
        '',
        false,
        true,
        true,
        false,
        500,
        1,
        false,
        false
    );

    const upload_assignment = new SmMetaFileModel(
      'upload_assignment',
      'upload_assignment',
      'file',
      false,
      'col-12 col-lg-6 col-md-6',
      4,
      7,
      '',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
      3000,
      250,
      510,
      'image',
      'upload_assignment',
      false,
      false,
      2000,
      3000
    );

      const save = new SmBtnMetaModel('Accept', '', true, false, true, false);
      const submit = new SmBtnMetaModel('Submit', '', true, false, true, false);
      const submitAssignment = new SmBtnMetaModel('Submit', '', true, false, true, false);
  
      return {
        description,
        document_path,
        student_feedback,
        upload_assignment,
        save,
        submit,
        submitAssignment,
        formInfo,
      };
    }
    // override getMetaModel(): MetaModel {
    //   const pageData = new MetaModel();
    //   pageData.pageTitle = this.pageTitle;
    //   pageData.properties = this.initProperties();
    //   pageData.redirectPath = this.redirectPath;
    //   pageData['pageKey'] = this.filterMeta;
    //   return pageData;
  // }
  }

  